import * as React from "react";
import { Redirect } from 'react-router-dom';

import { UserService } from "@fnv-core/authentication";
import { Slug } from '@fnv-core/utils';
import { PageHelpers } from "./helpers/PageHelpers";
import { PageRenderHelpers } from "./helpers/PageRenderHelpers";
import { PageProps } from "./interfaces/PageInterfaces";
import { MenuHelpers } from "./helpers/MenuHelpers";
import { MijnFNVPageContext } from "./helpers/MijnFNVPageContext";
import { FormService } from "../../services/FormService";
import {
  AnimationService,
  ANIMATION_DASHBOARD_LOADING_CONTEXT,
} from "../../services/AnimationService";
import fetch from 'cross-fetch';
import { InputStepperText } from '../../input-components/input-stepper-text';
import ReactHtmlParser from 'react-html-parser';
import { PopupError } from '../../presentational/PopupError';

export interface WebshopOverviewPageState {
  shoppingCart : any[];
  totalCount : number;
  redirectToUrl: string;
  shoppingCartIsValidated: boolean;
  shoppingCartIsValid : boolean;
  shoppingCartErrors : any;
  isShowPostDataError : boolean;
  errorText : string;
}

export class WebshopShoppingCartPage extends React.Component<PageProps, WebshopOverviewPageState> {

  state = {
    shoppingCart : [],
    totalCount : 0,
    redirectToUrl : "",
    shoppingCartIsValidated : false,
    shoppingCartIsValid: false,
    shoppingCartErrors : {},
    isShowPostDataError : false,
    errorText : ""
  };
  
  componentDidMount() {
    AnimationService.enableFormAnimations();
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);

    this.getProducts();
  }

  componentDidUpdate() {
    this.handleAnimations();
  }

  handleAnimations() {
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    AnimationService.triggerAnimations();
  }

  onClickAddProduct = (productSKU : string) => {
    
    fetch(`/api/shoppingbasket/add?id=${parseInt(productSKU)}&amount=1`, {
      method: 'post'      
    }).then(response => {
      this.getProducts();
    });
  }


  validateShoppingCart = () => {
    fetch("/api/shoppingbasket/validatecart", {
      method: 'get'      
    }).then(response => {
      if (response.status >= 300) {
        return { error: true };
      } else {
        return response.json();
      }
    })
    .then(result => {
      // tslint:disable-next-line      
      let errors: any = {};      
      result.map((error : any) => {
        errors[error.productId] = error;
      });
      this.setState({shoppingCartIsValid: result && result.length == 0, shoppingCartIsValidated : true, shoppingCartErrors: errors});            
    });
  }

  getProducts = () => {
    fetch("/api/shoppingbasket/get", {
      method: 'get'      
    }).then(response => {
      if (response.status >= 300) {
        return { error: true };
      } else {
        return response.json();
      }
    })
    .then(shoppingCart => {
      // tslint:disable-next-line
      let totalCount = 0;
      shoppingCart.map((cartItem, index) => {
        totalCount += cartItem.quantity;
      });

      this.setState({shoppingCart: shoppingCart, totalCount : totalCount, shoppingCartIsValidated : false, shoppingCartIsValid : false});
      this.validateShoppingCart();            
    });
  }

  onChangeValue = (cartItem, newValue) => {
    this.setState({shoppingCartIsValidated: false, shoppingCartIsValid: false}, () => {
      fetch(`/api/shoppingbasket/add?id=${parseInt(cartItem.productId)}&amount=${newValue}`, {
        method: 'post'      
      }).then(response => {
        this.getProducts();
      });
    });
  }

  onRemoveProduct = (cartItem) => {
    this.setState({shoppingCartIsValidated: false, shoppingCartIsValid: false}, () => {
      fetch(`/api/shoppingbasket/remove?id=${parseInt(cartItem.productId)}`, {
        method: 'post'      
      }).then(response => {
        this.getProducts();
      });
    });
  }

  onClickCheckoutButton = () => {
    const WebshopShoppingCartPagina = this.props.kenticoPage.MijnFnvWebshopShoppingCartPagina;
    if (WebshopShoppingCartPagina) {
      if (this.state.totalCount == 0) {
        this.setState({
          isShowPostDataError: true, 
          errorText: WebshopShoppingCartPagina.FoutmeldingGeenArtikelenInWinkelwagen
        });
        return;
      }
      if (!this.state.shoppingCartIsValid) {
        this.setState({
          isShowPostDataError: true, 
          errorText: WebshopShoppingCartPagina.FoutmeldingControleerWinkelwagen
        });
        return;
      }

      this.setState({redirectToUrl: WebshopShoppingCartPagina.OrderPageUrl});
    }
  }

  gotoProductDetail = (event, cartItem) => {
    event.preventDefault();
    if (cartItem && cartItem.productDetailUrl) {
      this.setState({redirectToUrl : cartItem.productDetailUrl});
    }
    return false;
  }

  render() {

    if (this.state.redirectToUrl !== undefined && this.state.redirectToUrl !== '') {
      return <Redirect to={this.state.redirectToUrl} />;
    }

    const WebshopShoppingCartPagina = this.props.kenticoPage.MijnFnvWebshopShoppingCartPagina;
    if (!WebshopShoppingCartPagina) {
      return <></>;
    }

    MenuHelpers.showBreadCrumbs();

    if (WebshopShoppingCartPagina.MenuType === "eenvoudig") {
      MenuHelpers.hideMenu();
    } else {
      MenuHelpers.showMenu();
    }

    PageHelpers.setBreadcrumbsPageTitle(WebshopShoppingCartPagina.Titel);

    const pageWidthCssClass = PageRenderHelpers.getCssClassForPageWidthViewPageType(
      "breed",
      false,
      false
    );

    let nameMemberInLidZoekenSubfunction = "";
    let memberState = <></>;
    if (
      this.context &&
      this.context.pathParam &&
      this.context.pathParam !== UserService.getUserId()
    ) {
      const memberDetails = FormService.getLidZoekenSubFunctionsForMember();
      if (memberDetails && memberDetails.memberName) {
        nameMemberInLidZoekenSubfunction = memberDetails.memberName;

        memberState = (
          <span
            className={
              "member-state " +
              (memberDetails.isMember ? "member-state--is-member" : "")
            }
          ></span>
        );
      }
    }

    const memberDetails = (
      <>
        {nameMemberInLidZoekenSubfunction &&
          nameMemberInLidZoekenSubfunction !== "" && (
            <h2 className="content__subtitle content__subtitle-member-name">
              {memberState}
              {nameMemberInLidZoekenSubfunction}
            </h2>
          )}
      </>
    );

    this.handleAnimations();
    const popupText = {
      isUserError: true,
      title: this.state.errorText,
      message: "",
      explanation: '',
      telephoneHint: "",
      telephoneNumber: "",
      telephoneText: "",
      okButtonText: "OK",
      email: "",
      emailInfo : "",
      linkUrl: "",
      container: this,
      stayOnPage: true
    };

    return (
      <React.Fragment>
        <div className="row  mijn-fnv__view-page webshop-page">
          <div className={"mijn-fnv__mainBlock col-12"}>
            <h1
              className={
                "mijn-fnv-" +
                Slug.fromString(WebshopShoppingCartPagina.Titel) +
                "__title"
              }
            >
              {WebshopShoppingCartPagina.Titel}
            </h1>
            {memberDetails}            
            <div className="content__hr"></div>
          </div>
        </div>        
        <div className="row webshop-shoppingcart">
          <div className="col-12 col-md-8">
            <div className="webshop-shoppingcart__products">
              {this.state.totalCount == 0 && <div className="webshop-shoppingcart__empty-cart">{WebshopShoppingCartPagina.FoutmeldingGeenArtikelenInWinkelwagen}</div>}
              {this.state.shoppingCart.map((cartItem, index) => {
                return <div key={"cart-" + index} className="col-12 webshop-shoppingcart__product">
                    <div className="webshop-shoppingcart__product-image position-relative">
                      <img src={cartItem.imageUrl} />
                      <a href="#" className="stretched-link" onClick={(event) => {return this.gotoProductDetail(event, cartItem); }}></a>
                    </div>
                  <div className="webshop-shoppingcart__productdetails position-relative">
                    <a href="#" className="stretched-link" onClick={(event) => {return this.gotoProductDetail(event, cartItem); }}></a> 
                    <div className="webshop-shoppingcart__product-name">{cartItem.description}</div>
                    <div className="webshop-shoppingcart__product-shortname">{ReactHtmlParser(cartItem.productShortName)}</div>
                    {this.state.shoppingCartErrors[cartItem.productId] && 
                      <div className="webshop-shoppingcart__error">{WebshopShoppingCartPagina.FoutmeldinErIsNietGenoegVoorraad}: {this.state.shoppingCartErrors[cartItem.productId].inventory}</div>}
                  </div>
                  <div className="webshop-shoppingcart__quantity">
                    <InputStepperText onChangeValue={this.onChangeValue.bind(this, cartItem)} maxValue={999} value={cartItem.quantity} enableTextInput={true}></InputStepperText>
                    <button onClick={this.onRemoveProduct.bind(this, cartItem)} className="webshop-shoppingcart__remove">Verwijderen</button>
                  </div>
                </div>;
              })}
              <div className="col-12 webshop-shoppingcart__total-count">
                <div className="webshop-shoppingcart__total-count-label">Aantal producten</div>
                <div className="webshop-shoppingcart__total-count-value">{this.state.totalCount}</div>
              </div>
              <div className="col-12 webshop-shoppingcart__total-amount">
                <div className="webshop-shoppingcart__total-amount-label">Totaal</div>
                <div className="webshop-shoppingcart__total-amount-value">Gratis</div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="webshop-shoppingcart__checkout">                            
              <button onClick={this.onClickCheckoutButton} className="btn btn-success webshop-shoppingcart__checkout-button">
                <span>{WebshopShoppingCartPagina.OrderButton}</span>
              </button>
              <div className="webshop-shoppingcart__order-reasons">
                {ReactHtmlParser(WebshopShoppingCartPagina.OrderReasons)}
              </div>              
            </div>
          </div>
        </div>
        {this.state.isShowPostDataError ? <PopupError {...popupText} /> : null}
      </React.Fragment>
    );
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}